import { render } from "./StartupsPage.vue?vue&type=template&id=0f5de2d6&scoped=true"
import script from "./StartupsPage.vue?vue&type=script&lang=js"
export * from "./StartupsPage.vue?vue&type=script&lang=js"

import "./StartupsPage.vue?vue&type=style&index=0&id=0f5de2d6&scoped=true&lang=css"
import "./StartupsPage.vue?vue&type=style&index=1&id=0f5de2d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5de2d6"]])

export default __exports__